import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingsService } from '../../../core/settings/settings.service';
import { PlatformService } from '../../../platform/platform.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  valForm;
  errorMessage = '';
  errorFiltro = '';
  operacao = 'manual';
  constructor(
    public settings: SettingsService,
    public platform: PlatformService,
    private router: Router,
    fb: UntypedFormBuilder
  ) {
    this.valForm = fb.group({ cpf: ['', Validators.required], password: ['', Validators.required], remember: [false] });
  }
  async ngOnInit() {
    if (sessionStorage.getItem('AUTH') || localStorage.getItem('AUTH')) {
      this.operacao = 'auto';
      try {
        await this.platform.refresh();
        await this.router.navigateByUrl('/projetos');
      } catch {
        this.operacao = 'manual';
      }
    }
  }
  voltarLogin() {
    this.platform.clear();
    this.operacao = 'manual';
  }
  async submitForm(event: Event, value: any) {
    event.preventDefault();
    this.valForm.markAllAsTouched();
    if (!this.valForm.valid) return;
    this.errorMessage = '';
    this.operacao = 'auto';
    try {
      await this.platform.login(value.cpf, value.password, value.remember);
    } catch (e: any) {
      this.operacao = 'manual';
      this.errorMessage = e?.error?.message || 'Não foi possível entrar';
    }
  }
}
